<template>
	<div>
		<Form ref="formInline" :label-width="150">
			<Divider orientation="left"><b>打印设置</b></Divider>
			<Row>
				<Col :xxl="10" :sm="20" :lg="16" :xl="14">
					<FormItem>
						<p slot="label">分拣标签</p>
						<Select v-model="printSetting.fenjianPrint" style="width:200px" placeholder="请选择打印设备" size="large">
							<Option v-for="item in printSet" :value="item.key" :key="item.value" :label="item.value">
								<span>{{item.value}}</span>
							</Option>
						</Select>
						<Select v-model="printSetting.fenjianPrintTemplate" style="width:200px" placeholder="请选择打印模板" size="large">
							<Option v-if="item.type==1" v-for="item in printTemplateList" :value="item.id" :key="item.id" :label="item.name">
								<span>{{item.name}}</span>
							</Option>
						</Select>
					</FormItem>
					<FormItem>
						<p slot="label">装箱标签</p>
						<Select v-model="printSetting.packingBoxPrint" style="width:200px" placeholder="请选择打印设备" size="large">
							<Option v-for="item in printSet" :value="item.key" :key="item.value" :label="item.value">
								<span>{{item.value}}</span>
							</Option>
						</Select>
						<Select v-model="printSetting.packingBoxPrintTemplate" style="width:200px" placeholder="请选择打印模板" size="large">
							<Option v-if="item.type==13" v-for="item in printTemplateList" :value="item.id" :key="item.id" :label="item.name">
								<span>{{item.name}}</span>
							</Option>
						</Select>
					</FormItem>
					<FormItem>
						<p slot="label">预分拣标签</p>
						<Select v-model="printSetting.prefenjianPrint" style="width:200px" placeholder="请选择打印设备" size="large">
							<Option v-for="item in printSet" :value="item.key" :key="item.value" :label="item.value">
								<span>{{item.value}}</span>
							</Option>
						</Select>
						<Select v-model="printSetting.prefenjianPrintTemplate" style="width:200px" placeholder="请选择打印模板" size="large">
							<Option v-if="item.type==14" v-for="item in printTemplateList" :value="item.id" :key="item.id" :label="item.name">
								<span>{{item.name}}</span>
							</Option>
						</Select>
					</FormItem>
					<FormItem>
						<p slot="label">测试打印</p>
						<Button size="large" @click="printTest">打印</Button>
						<a href="https://media.yinghecloud.com/yinghecloud/files/CLodop_Setup_for_Win32NT.zip">下载打印控件</a>
					</FormItem>
				</Col>
			</Row>
			<Divider orientation="left"><b>电子秤设置</b></Divider>
			<Row>
				<Col :xxl="10" :sm="20" :lg="16" :xl="14">
        <FormItem>
						<p slot="label">电子秤协议</p>
						<Select v-model="weightAgreement"  style="width:300px" placeholder="请选择电子秤协议" size="large">
							<Option v-for="item in weightAgreementList" :value="item.id" :key="item.id" :label="item.name">
								<span>{{item.name}}</span>
							</Option>
						</Select>
					</FormItem>
					<FormItem>
						<p slot="label">应用ID</p>
						<Input v-model="weightSerial" placeholder="请输入电子秤应用ID" style="width:300px" size="large"/>
						<Button v-if="$store.state.hasChromeApp && !loading" type="success" @click="connectWeightDevice">已连接
						</Button>
						<Button v-if="!$store.state.hasChromeApp && !loading" type="error" @click="connectWeightDevice">连接
						</Button>
						<Button v-if="loading" type="error" :loading="loading">连接中</Button>
					</FormItem>
					<FormItem>
						<p slot="label">电子秤数据</p>
						<span><Alert type="warning">请放置物品至称重台，并观察页面顶部电子秤读数是否正常</Alert></span>
					</FormItem>
				</Col>
			</Row>
			<!--<Row>
				<Col :xxl="10" :sm="20" :lg="16" :xl="14">
					<FormItem>
						<Button type="primary" @click="savePrint()" long size="large">保存</Button>
					</FormItem>
				</Col>
			</Row>-->
		</Form>
		<div style="height: 100px;">
			<div class="bottomOperationBoxWrapper">
				<div class="bottomOperationBox">
					<Button type="primary" @click="savePrint()" long size="large" style="width: 50%;">保存</Button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import {queryPrintTemplateList} from '@/api/sorting/sorting';
    import {getPrintDevices, printByTemplate, printByTemplateV2} from "../../../util/printUtil";

	export default {
		name: "hardwareSetting",
		data() {
			return {
				loading: false,
				printSet: [], // 打印设备
				// 打印设置
				printSetting: {
					fenjianPrint: null,
					fenjianPrintTemplate: null,
					packingBoxPrint: null,
					packingBoxPrintTemplate: null,
					prefenjianPrint: null,
					prefenjianPrintTemplate: null,


					/*caigouPrint: null, // 设备
					caigouPrintTemplate: null, // 模板

					peisongPrint: null,
					peisongPrintTemplate: null,

					duihuoPrint: null,
					duihuoPrintTemplate: null,

					orderPrint: null,
					orderPrintTemplate: null,

					sortingListPrint: null,
					sortingListPrintTemplate: null,*/
				},
				weightSerial: "", // chrome app电子秤ip
				// 打印模板
				printTemplateList: [],
        weightAgreement: null, // 电子秤协议
        // 电子秤协议列表
				weightAgreementList: [
					{id: "1", name: "通用协议"},
					{id: "2", name: "顶尖协议"},
					{id: "3", name: "大华协议"}
				],
			};
		},
		methods: {
			// 查询模板数据
			queryPrintTemplateList() {
				queryPrintTemplateList({rows: 100}).then(data => {
					if (data.data.code == 1200) {
						this.printTemplateList = data.data.data.rows;
					} else {
						this.$Message.error(data.data.msg)
					}
				})
			},
			async savePrint() {
				let printSetting = localStorage.getItem("printSet");
				if (printSetting) {
					printSetting = JSON.parse(printSetting);
					printSetting.fenjianPrint = this.printSetting.fenjianPrint;
					printSetting.fenjianPrintTemplate = this.printSetting.fenjianPrintTemplate;

					printSetting.prefenjianPrint = this.printSetting.prefenjianPrint;
					printSetting.prefenjianPrintTemplate = this.printSetting.prefenjianPrintTemplate;

					printSetting.packingBoxPrint = this.printSetting.packingBoxPrint;
					printSetting.packingBoxPrintTemplate = this.printSetting.packingBoxPrintTemplate;
				} else {
					printSetting = this.printSetting;
				}
				localStorage.setItem("printSet", JSON.stringify(printSetting));
				localStorage.setItem("weightSerial", this.weightSerial);
        localStorage.setItem("weightAgreement", this.weightAgreement);
				this.connectWeightDevice();
				this.$Message.success("保存成功");
			},
			// 连接电子秤
			async connectWeightDevice() {
				let weightSerial = this.weightSerial;
				if (weightSerial) {
					localStorage.setItem("weightSerial", weightSerial);
					this.$store.state.hasChromeApp = false;
					this.loading = true;
					let result = await this.$store.dispatch("initChromeApp");
					if (result !== true) {
						setTimeout(() => {
							this.$Notice.error({title: "电子秤连接失败，请检查应用ID", duration: 0});
							this.loading = false;
						}, 500);
					} else {
						setTimeout(() => {
							this.$Notice.success({title: "电子秤连接成功"});
							this.loading = false;
						}, 500);
					}
				}
			},
			// 测试打印
			printTest() {
				if (!this.printSetting.fenjianPrint) {
					return this.$Notice.error({title: "请绑定打印设备",});
				}
				if (!this.printSetting.fenjianPrintTemplate) {
					return this.$Notice.error({title: "请绑定打印模板",});
				}
				let product = {
					sku_name: "演示商品（非标品）",
					deliver_user_name: "悦邻精选",
					product_num: 3,
					sort_number: "2.6斤",
					lineTitle: "西区-A1"
				};
				let printTemplate = {};
				for (let i = 0; i < this.printTemplateList.length; i++) {
					if (this.printSetting.fenjianPrintTemplate == this.printTemplateList[i].id) {
						printTemplate = {
							page: this.printTemplateList[i].page,
							type: this.printTemplateList[i].type,
							printTemplate: this.printTemplateList[i].print_template,
              template_grade: this.printTemplateList[i].template_grade,
						};
					}
				}
        if(printTemplate.template_grade == 2){ // 新版打印
          printByTemplateV2(printTemplate.printTemplate, [product], this.printSetting.fenjianPrint);
        }else{
          printByTemplate(product.id + "sorting", 1, this.printSetting.fenjianPrint, product, printTemplate);
        }
			},
			// 初始化页面
			initPage() {
				this.queryPrintTemplateList();
				let printInfo = localStorage.getItem("printSet");
				if (printInfo) {
					let printData = JSON.parse(printInfo);
					this.printSetting = printData;
				}
				this.weightSerial = localStorage.getItem("weightSerial");
        this.weightAgreement = localStorage.getItem("weightAgreement");
				setTimeout(() => {
					let device = getPrintDevices();
					// console.log(device)
					if (device) {
						localStorage.setItem("printSetArr", JSON.stringify(device));
					}
					this.printSet = device;
				}, 2000);
			},
		},
		mounted() {

		},
		activated() {
		}
		/*watch: {
			// 监听路由变化
			$route(to, from) {
				this.$destroy(); // 销毁页面
			}
		}*/
	};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/view/system/components/hardwareSetting.vue